import React from 'react';

import { ClosedOffer, ExperimentationData } from 'sellDirect/OfferContext';
import { DocumentsSection } from 'sellDirect/components/closingDash/DocumentsSection';
import { SupportSection } from 'sellDirect/components/closingDash/SupportSection';
import { ClosingTasks } from 'sellDirect/helpers/closingTasks';
import { SellDirectLayout } from 'sellDirect/components/offer/SellDirectLayout';
import { SellingModule } from 'sellDirect/components/overview/SellingModule';
import { useQualificationContext } from 'shared/helpers/QualificationContext';

export interface ClosedOfferPageProps {
  isLoading: boolean;
  offer: ClosedOffer;
  closingTasks: ClosingTasks;
  experimentationData?: ExperimentationData;
}

/** Serves the same purpose as src/routes/Selling.tsx, but for closing states only. */
export const ClosedOfferPage: React.FC<ClosedOfferPageProps> = ({
  isLoading,
  offer,
  closingTasks,
}) => {
  const { lead, customerLeads } = useQualificationContext();

  return (
    <SellDirectLayout isLoading={isLoading} address={offer.address}>
      <SellingModule offer={offer} customerLeads={customerLeads} lead={lead} />
      <SupportSection contactTypes={['experiencePartner', 'titleAndEscrow']} />
      <DocumentsSection offer={offer} closingTasks={closingTasks} />
    </SellDirectLayout>
  );
};
